import { Icon } from '@iconify/react';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import CryptoJS from 'crypto-js';
import { useState } from 'react';
// material
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
// react icons
import { MdAssignmentInd, MdOutlinePermContactCalendar } from 'react-icons/md';
// material icons
import CloseIcon from '@mui/icons-material/Close';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import SettingsAccessibilityIcon from '@mui/icons-material/SettingsAccessibility';
// other icons
import searchFill from '@iconify/icons-eva/search-fill';
import add from '@iconify/icons-ic/add';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import { useDispatch } from 'react-redux';
import 'react-date-range/dist/theme/default.css'; // theme css file
import { fDate } from '../../utils/formatTime';
import { DateRangeStyled, RootStyle, SearchStyle } from '../Global/Styling';
// ----------------------------------------------------------------------
import { PARTNER_TO_OFFLINE_URL, domainUrl } from '../services/globalApi';
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import useLeadSelector from '../../store/Slice/Lead/LeadSelector';
// import { getRecoEngineApi } from 'src/store/Slice/Lead/LeadSlice';
import { getRecoEngineApi } from '../../store/Slice/Lead/LeadSlice';
import { LeadApi } from '../../utils/Apis';
// import useLoginSelector from 'src/store/Slice/Login/LoginSelector';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

export default function LeadsToolbar({
  filterName,
  onFilterName,
  selectProduct,
  setSelectProduct,
  onFilterProduct,
  selectStatus,
  onFilterStatus,
  selected,
  filterDatesRange,
  setFilterDatesRange,
  cityListData,
  setCityListData,
  onAssignSubmit,
  openAssign,
  setOpenAssign,
  assignValue,
  setAssignValue,
  alertMsg,
  setAlertMsg,
  setSelectSource,
  setSelectStatus,
  setFilterName,
  leadsListResponse,
  selectLeadSource,
  setSelectLeadSource,
  onFilterLeadSource
}) {
  const navigate = useNavigate();
  const [isOpenFilter, openFilter] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [showTextfield, setShowTextfield] = useState(false);
  const { LoginData } = useLoginSelector();
  const dispatch = useDispatch();

  const { LoanTypeDrop, MasterTypeListDrop, InternalSaleManagerFilterDrop, CityDrop } =
    useGlobalSelector();
  const { LeadListStatusDrop } = useLeadSelector();

  // console.log('LoginData222', LoginData);

  const handleRemoveFilter = (e) => {
    setFilterDatesRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection'
      }
    ]);
    setSelectProduct(' ');
    setCityListData(null);
    setSelectStatus(' ');
    setSelectSource(' ');
    setSelectLeadSource(' ');
    setFilterName('');
  };

  async function handleRecoEngineSection() {
    const userId = LoginData?.userId;
    const result = await dispatch(getRecoEngineApi({ userId }));

    // console.log('result2222', result);

    const qrUrl = result?.data?.qrUrl;

    if (!qrUrl) {
      console.error('QR URL not found');
      return;
    }

    const payload = JSON.stringify({ qrUrl, userId });

    // Step 1: Open a blank page
    const newWindow = window.open(qrUrl, '_blank', 'noopener,noreferrer');
  }

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={2}>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectProduct}`
                }}
                value={selectProduct}
                onChange={onFilterProduct}
              >
                <MenuItem value=" " disabled>
                  Select Product
                </MenuItem>
                {LoanTypeDrop?.length > 0 &&
                  LoanTypeDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs sx={{ position: 'relative' }}>
              <Box className="displayDateRange">
                {filterDatesRange[0].startDate !== null
                  ? `${fDate(filterDatesRange[0].startDate)} to `
                  : ''}
                {filterDatesRange[0].endDate !== null ? fDate(filterDatesRange[0].endDate) : ''}
                {filterDatesRange[0].startDate === null && filterDatesRange[0].endDate === null ? (
                  <Typography className="dissabledMenu">Select Date Range</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Select
                fullWidth
                inputProps={{
                  className: 'textInput'
                }}
                MenuProps={{
                  className: 'menuOpened'
                }}
                value=" "
                className="datesSelect"
              >
                <DateRangeStyled
                  editableDateInputs={false}
                  onChange={(item) => setFilterDatesRange([item.selection])}
                  moveRangeOnFirstSelection={false}
                  ranges={filterDatesRange}
                  className="dateRangePicker"
                />
              </Select>
            </Grid>
            {/* {console.log('sss CityDrop', CityDrop)} */}
            {/* {console.log('sss cityListData', cityListData)} */}
            <Grid item xs>
              <Autocomplete
                id="combo-box-demo1"
                options={CityDrop || []}
                size="small"
                value={cityListData || null}
                onChange={(e, newValue) => {
                  setCityListData(newValue);
                }}
                // compare options to value by `value` (or fallback to object/string equality)
                isOptionEqualToValue={(option, val) => {
                  const optVal = option?.value ?? option;
                  const valVal = val?.value ?? val;
                  // do strict equality (handles number/string matches too)
                  return String(optVal) === String(valVal);
                }}
                getOptionLabel={(option) => {
                  if (!option) return '';
                  if (typeof option === 'string') return option;
                  // handle both { label, value } and { cityName, ... } shapes
                  return option.label ?? option.cityName ?? '';
                }}
                renderOption={(props, option) => (
                  <li {...props}>{option?.label ?? option?.cityName ?? ''}</li>
                )}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select City" />
                )}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectStatus}`
                }}
                value={selectStatus}
                onChange={onFilterStatus}
              >
                <MenuItem value=" " disabled>
                  Select Status
                </MenuItem>
                {LeadListStatusDrop?.length > 0 &&
                  LeadListStatusDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            {/* do not delete this select box */}
            <Grid item xs>
              <Select
                fullWidth
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${selectLeadSource}`
                }}
                value={selectLeadSource}
                onChange={onFilterLeadSource}
              >
                <MenuItem value=" " disabled>
                  Select Lead Source
                </MenuItem>
                {MasterTypeListDrop?.length > 0 &&
                  MasterTypeListDrop?.map((item, index) => (
                    <MenuItem value={item?.value} key={item?.value}>
                      {item?.label}
                    </MenuItem>
                  ))}
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          borderBottom: '1px solid #e2e8f0',
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: { xs: 'flex-start', sm: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          p: { xs: 2, sm: 2.5 },
          bgcolor: '#ffffff'
        }}
      >
        <Box display="flex" gap={1.25} flexWrap="wrap" alignItems="center">
          {LoginData?.isReAccess === true && (
            <Button
              variant="contained"
              onClick={() => handleRecoEngineSection()}
              startIcon={<Icon icon={add} />}
              sx={{
                bgcolor: '#0284c7',
                color: '#ffffff',
                borderRadius: '10px',
                px: 2.2,
                py: 0.9,
                fontWeight: 600,
                fontSize: '13px',
                textTransform: 'none',
                boxShadow: '0 4px 14px rgba(2, 132, 199, 0.25)',
                '&:hover': { bgcolor: '#0369a1' }
              }}
            >
              Add Application
            </Button>
          )}

          <Button
            variant="outlined"
            onClick={() => {
              navigate(`/leads/appointment`);
              localStorage.setItem('leadList', JSON.stringify(leadsListResponse));
            }}
            startIcon={<MdOutlinePermContactCalendar size={18} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            My Appointment
          </Button>

          <Button
            variant="outlined"
            disabled={selected && selected.length < 1}
            onClick={() => {
              setOpenAssign(true);
              setAlertMsg(false);
              setAssignValue(' ');
            }}
            startIcon={<MdAssignmentInd size={18} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: '#475569',
              borderColor: '#e2e8f0',
              bgcolor: '#ffffff',
              px: 1.75,
              py: 0.8,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.04)',
                color: '#0284c7'
              }
            }}
          >
            Assign ({selected?.length || 0})
          </Button>
        </Box>

        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        >
          <TextField
            size="small"
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Leads..."
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Icon icon={searchFill} style={{ color: '#94a3b8', fontSize: 18 }} />
                </InputAdornment>
              )
            }}
            sx={{
              width: { xs: '100%', sm: 260 },
              '& .MuiOutlinedInput-root': {
                bgcolor: '#fff',
                borderRadius: '10px',
                fontSize: '13px',
                '& fieldset': { borderColor: '#e2e8f0' },
                '&:hover fieldset': { borderColor: '#cbd5e1' },
                '&.Mui-focused fieldset': { borderColor: '#0284c7' }
              }
            }}
          />

          <Button
            variant="outlined"
            onClick={() => openFilter(!isOpenFilter)}
            startIcon={<Icon icon={roundFilterList} />}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              fontWeight: 600,
              fontSize: '13px',
              color: isOpenFilter ? '#0284c7' : '#475569',
              borderColor: isOpenFilter ? '#0284c7' : '#e2e8f0',
              bgcolor: isOpenFilter ? 'rgba(2, 132, 199, 0.06)' : '#fff',
              height: 40,
              px: 2,
              '&:hover': {
                borderColor: '#0284c7',
                bgcolor: 'rgba(2, 132, 199, 0.06)',
                color: '#0284c7'
              }
            }}
          >
            Filters
          </Button>
        </Box>
      </RootStyle>
      <Dialog
        open={openAdd}
        onClose={(e) => setOpenAdd(false)}
        fullWidth
        PaperProps={{ sx: { borderRadius: '16px' } }}
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Select Mode of Application Submission</Typography>
          <IconButton onClick={(e) => setOpenAdd(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid
            container
            spacing={3}
            display="flex"
            justifyContent="space-between"
            textAlign="center"
            mb={2}
          >
            <Grid item xs={4}>
              <Box className="appSubmissionLinkB">
                <EmojiPeopleIcon className="appSubLinkIcon" />
                <Typography variant="subtitle1">Recommendation</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                onClick={(e) => {
                  const authToken = LoginData?.jwt;
                  const companyId = LoginData?.companyId;
                  const userId = LoginData?.userId;
                  const appToken = CryptoJS.AES.encrypt('null', 'appToken').toString();
                  const companyToken = CryptoJS.AES.encrypt(
                    String(companyId),
                    'companyToken'
                  ).toString();
                  const userToken = CryptoJS.AES.encrypt(authToken, 'userToken').toString();
                  const leadToken = CryptoJS.AES.encrypt('null', 'leadToken').toString();
                  const userIdToken = CryptoJS.AES.encrypt(String(userId), 'userId').toString();
                  window.open(
                    `${PARTNER_TO_OFFLINE_URL}/?u=${encodeURIComponent(
                      userToken
                    )}&c=${encodeURIComponent(companyToken)}&a=${encodeURIComponent(
                      appToken
                    )}&l=${encodeURIComponent(leadToken)}&ui=${encodeURIComponent(userIdToken)}`,
                    `_blank`
                  );
                  setOpenAdd(false);
                }}
              >
                <PeopleAltIcon className="appSubLinkIcon" />
                <Typography variant="subtitle1">Application</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                // onClick={(e) => {
                //   window.open(`http://manual.kalolytic.com/`, `_blank`);
                //   setOpenAdd(false);
                // }}
              >
                <SettingsAccessibilityIcon className="appSubLinkIcon" />
                <Typography variant="subtitle2">Referral</Typography>
              </Box>
            </Grid>
          </Grid>
          {showTextfield === 'true' && (
            <Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  placeholder="Type master name..."
                />
              </Box>
              <Box>
                <TextField
                  fullWidth
                  inputProps={{
                    className: 'textInput'
                  }}
                  placeholder="Type master name..."
                />
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={openAssign}
        onClose={() => {
          setOpenAssign(false);
          setAlertMsg(false);
        }}
        fullWidth
        PaperProps={{ sx: { borderRadius: '16px' } }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontWeight: 700,
            fontSize: '1.1rem'
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            {selected && selected.length} Leads Selected
          </Typography>
          <IconButton
            onClick={(e) => {
              setOpenAssign(false);
              setAlertMsg(false);
            }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Select
            fullWidth
            size="small"
            inputProps={{
              className: `textInput customSelectBox dissabledMenu${assignValue}`
            }}
            value={assignValue}
            onChange={(e) => {
              setAlertMsg(false);
              setAssignValue(e.target.value);
            }}
            sx={{ borderRadius: '8px' }}
          >
            <MenuItem value=" " disabled>
              Select Sales Person
            </MenuItem>
            {InternalSaleManagerFilterDrop?.length > 0 &&
              InternalSaleManagerFilterDrop?.map((item, index) => (
                <MenuItem value={item?.value} key={item?.value}>
                  {item?.label}
                </MenuItem>
              ))}
          </Select>
          {alertMsg === true && <FormHelperText error>Please select sales person</FormHelperText>}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button
            onClick={() => {
              setOpenAssign(false);
              setAlertMsg(false);
            }}
            variant="outlined"
            sx={{
              borderRadius: '8px',
              textTransform: 'none',
              borderColor: '#e2e8f0',
              color: '#637381',
              '&:hover': { borderColor: '#cbd5e1', bgcolor: '#f8fafc' }
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onAssignSubmit}
            variant="contained"
            sx={{
              bgcolor: '#13519d',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 600,
              px: 3,
              boxShadow: '0 4px 14px rgba(19,81,157,0.25)',
              '&:hover': { bgcolor: '#0d3b75' }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
